import request from '@/utils/request'

// 查询结算周期列表
export function listPeriod(query) {
  return request({
    url: '/settlement/period/list',
    method: 'get',
    params: query,
  })
}

// 查询结算周期分页
export function pagePeriod(query) {
  return request({
    url: '/settlement/period/page',
    method: 'get',
    params: query,
  })
}

// 查询结算周期详细
export function getPeriod(data) {
  return request({
    url: '/settlement/period/detail',
    method: 'get',
    params: data,
  })
}

// 新增结算周期
export function addPeriod(data) {
  return request({
    url: '/settlement/period/add',
    method: 'post',
    data: data,
  })
}

// 修改结算周期
export function updatePeriod(data) {
  return request({
    url: '/settlement/period/edit',
    method: 'post',
    data: data,
  })
}

// 删除结算周期
export function delPeriod(data) {
  return request({
    url: '/settlement/period/delete',
    method: 'post',
    data: data,
  })
}
